import { readUserAuthToken } from "./read-user-auth-token";
import { LoadingStateOps } from "../../../domain/data-layer/loading-state";
import { AuthClient } from "../../../domain/auth/user-auth/auth-client";
import { nonExpiredToken } from "./utils";
import { ANONYMOUS_TOKEN_BROWSER_STORAGE_KEY, logger, USER_TOKEN_BROWSER_STORAGE_KEY } from "./state";
import { UserAspectState } from "./aspect-types";

export function getStateFromPersistence(): UserAspectState {
  const persistedState = getPersistedState();

  if (!persistedState) {
    return null;
  }

  switch (persistedState.tag) {
    case "logged-in-user": {
      return {
        tag: "logged-in-user",
        authToken: persistedState.authToken,
        userData: undefined,
        userProfileSf: LoadingStateOps.loadingS,
      };
    }
    case "anonymous-user": {
      return {
        tag: "anonymous-user",
        authToken: persistedState.authToken,
      };
    }
    default: {
      const _: never = persistedState;
      return _;
    }
  }
}

function getPersistedState(): UserAspectState {
  const maybeValidUserToken = readUserAuthToken(USER_TOKEN_BROWSER_STORAGE_KEY);
  const maybeValidAnonymousToken = readUserAuthToken(ANONYMOUS_TOKEN_BROWSER_STORAGE_KEY);

  if (maybeValidUserToken) {
    return {
      tag: "logged-in-user",
      authToken: maybeValidUserToken,
      userData: undefined,
      userProfileSf: LoadingStateOps.loadingS,
    };
  } else if (maybeValidAnonymousToken) {
    return {
      tag: "anonymous-user",
      authToken: maybeValidAnonymousToken,
    };
  } else {
    return null;
  }
}

export async function createNewAnonymousUser() {
  const anonymousToken = await AuthClient.getAnonymousAccessToken();

  return {
    tag: "anonymous-user" as const,
    authToken: anonymousToken,
  };
}
